import { instance, errorService } from '@/services/api'
import { dropdownAPIs, masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/PropertyUnits'
import TakeOffGroupingComponent from '@/components/DynamicComponents/Admin/MasterData/TakeOffGrouping'
import { tableName } from '@/services/config'

export default {
  components: {
    importTemplates,
    TakeOffGroupingComponent,
    exportTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
    ContractComponent,
    CategoryCodeComponent,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
      const regUnitCost = /^(?!$)\d{0,13}(?:\.\d{1,2})?$/
      let field = rule.field
      switch (rule.field) {
        case 'unit_Cost':
          field = 'unit cost'
          break
        case 'cost_Mult':
          field = 'cost mult'
          break
        default:
          field = rule.field
          break
      }
      if (rule.field === 'nrmL_Life') {
        if (value && !reg.test(value)) {
          callback(
            new Error('Please enter valid nrml life (for e.g.: 12345678.12)'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'unit_Cost') {
        if (value && !regUnitCost.test(value)) {
          callback(
            new Error('Please enter valid unit cost (for e.g.: 1234567891234.12)'),
          )
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(
            new Error(
              'Please enter valid ' + field + ' (for e.g.: 12345678.12)',
            ),
          )
        } else {
          callback()
        }
      }
    }
    const checTextkLength = (rule, value, callback) => {
      if (rule.field === 'description' || rule.field === 'source') {
        let field = 'Description'
        if (rule.field === 'source') {
          field = 'Source'
        }
        if (String(value).length > 100) {
          callback(
            new Error(field + ' must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        let field = 'Original description'
        if (rule.field === 'comments') {
          field = 'Comments'
        }
        if (String(value).length > 255) {
          callback(
            new Error(field + ' must be less than or equals to 255 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      fileInput: null,
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'id',
      defaultSortOrder: true,
      page: 0,
      pageSize: 50,
      takeoffList: [],
      visible: false,
      visibleTakeoff: false,
      modalTitle: '',
      form: {
        id: undefined,
        description: undefined,
        unit: undefined,
        unit_Cost: undefined,
        contract_Details_Id: undefined,
        master_Contract_Details_Id: undefined,
        source: undefined,
        cost_Mult: 1.0,
        nrmL_Life: undefined,
        original_Description: '',
        asset_Class: undefined,
        comments: '',
        category_Code_Id: undefined,
        master_Category_Code_Id: undefined,
        takeoff_Grouping_Ids: undefined,
        master_Takeoff_Grouping_Ids: undefined,
        takeoff_Groupings: [],
        isActive: 1,
        contractName: undefined,
        categoryCode: undefined,
        unit_Id: undefined,
        master_Unit_Id: undefined,
      },
      rules: {
        description: [
          {
            required: true,
            message: 'Please enter takeoff description',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        unit: [
          { required: true, message: 'Please select unit', trigger: 'change' },
        ],
        unit_Cost: [
          {
            required: true,
            message: 'Please enter unit cost',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        categoryCode: [
          {
            required: true,
            message: 'Please select category code',
            trigger: 'change',
          },
        ],
        contractName: [
          {
            required: true,
            message: 'Please select contract',
            trigger: 'change',
          },
        ],
        source: [
          { required: true, message: 'Please enter source', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        cost_Mult: [
          {
            required: true,
            message: 'Please enter cost mult',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        nrmL_Life: [{ validator: checkLength, trigger: 'blur' }],
        original_Description: [
          { message: 'Please enter original description', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        asset_Class: [
          {
            required: true,
            message: 'Please enter asset class',
            trigger: 'blur',
          },
        ],
        comments: [
          { message: 'Please enter comments', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        takeoff_Groupings: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one takeoff grouping',
            trigger: 'change',
          },
        ],
      },
      unitList: [],
      categoryCodeList: [],
      takeoffGroupingList: [],
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: 'auto',
      height: '400px',
      currency: null,
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.takeoff,
      loadImport: false,
      filters: {},
      contractList: [],
      isAddContract: false,
      isAddCategory: false,
      takeoff_Groupings: [],
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: gridProperties.master.columns.takeoff,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
    if (this.role === 'Admin') {
      this.getDropdowns()
    }
  },
  mounted() {
    this.$root.$on('deleteTakeoff', this.deleteTakeoff)
    this.$root.$on('editTakeoff', this.getTakeoffById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '9') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.takeoffList = []
        this.loading = true
        this.getDropdowns()
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('deleteTakeoff')
    this.$root.$off('editTakeoff')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      gridProperties.master.columns.takeoff.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.type === 'Template'
        }
      })
    },

    // Refresh Takeoff
    refreshTakeoffs() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.takeoffList = []
      this.page = 0
      this.defaultSortedBy = 'id'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'id',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTakeoffs(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      this.visibleTakeoff = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Takeoff
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Takeoff'
      this.form.id = undefined
      this.form.takeoff_Grouping_Ids = undefined
      this.form.contract_Details_Id = undefined
      this.form.category_Code_Id = undefined
      this.form.master_Contract_Details_Id = undefined
      this.form.master_Takeoff_Grouping_Ids = undefined
      this.form.master_Category_Code_Id = undefined
      this.form.isActive = 1
      this.takeoff_Groupings = []
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.form.cost_Mult = 1.0
    },

    // Save Takeoff
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url
          let method
          const groups = []
          this.takeoff_Groupings.forEach(element => {
            groups.push({ id: element.id, takeoffGrouping: element.name })
          })
          const req = {
            takeoff: this.form.description,
            categoryId: this.form.category_Code_Id,
            contractId: this.form.contract_Details_Id,
            unitId: this.form.unit_Id,
            unitCost: this.form.unit_Cost,
            source: this.form.source,
            costMult: this.form.cost_Mult,
            nrmlLife: this.form.nrmL_Life ? this.form.nrmL_Life : undefined,
            description: this.form.original_Description,
            comments: this.form.comments,
            takeoffGroupings: groups,
          }
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.takeoff.details(this.form.id)
          } else {
            Object.assign(req, { id: 0 })
            method = 'post'
            url = masterAPIs.takeoff.add
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update Takeoff' : 'Create Takeoff',
                this.form.id
                  ? 'Takeoff updated successfully!'
                  : 'Takeoff created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.takeoffList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.takeoffList = newData
              } else {
                this.getTakeoffs(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Get Takeoffs
    getTakeoffs(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        id: _.get(this.filters, 'id', undefined),
        takeoffGrouping: _.get(this.filters, 'takeoffGroupings', undefined),
        takeoff: _.get(this.filters, 'takeoff', undefined),
        contract: _.get(this.filters, 'contract', undefined),
        categoryCode: _.get(this.filters, 'categoryCode', undefined),
        assetClass: _.get(this.filters, 'assetClass', undefined),
        source: _.get(this.filters, 'source', undefined),
        unit: _.get(this.filters, 'unit', undefined),
        unitCost: _.get(this.filters, 'unitCost', undefined),
        costMult: _.get(this.filters, 'costMult', undefined),
        nrmlLife: _.get(this.filters, 'nrmlLife', undefined),
        description: _.get(this.filters, 'description', undefined),
      }
      instance
        .post(masterAPIs.takeoff.list, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.takeoffList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'takeoffTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Takeoff By Id
    getTakeoffById(id) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      instance
        .get(masterAPIs.takeoff.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.source = _.get(response.data, 'result.source', null)
          this.form.unit = _.get(response.data, 'result.unit', null)
          this.form.takeoff_Groupings = []
          this.takeoff_Groupings = []
          this.form.cost_Mult = _.get(response.data, 'result.costMult', null)
          this.form.comments = _.get(response.data, 'result.comments', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.nrmL_Life = _.get(response.data, 'result.nrmlLife', null)
          this.form.asset_Class = _.get(
            response.data,
            'result.assetClass',
            null,
          )
          this.form.category_Code_Id = _.get(
            response.data,
            'result.categoryId',
            null,
          )
          this.form.contract_Details_Id = _.get(
            response.data,
            'result.contractId',
            null,
          )
          this.form.description = _.get(response.data, 'result.takeoff', null)
          this.form.original_Description = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form.contractName = this.contractList.find(
            element => element.id === this.form.contract_Details_Id,
          ).value
          this.form.categoryCode = this.categoryCodeList.find(
            element => element.id === this.form.category_Code_Id,
          ).value
          const takeoffGroupings = _.get(
            response.data,
            'result.takeoffGroupings',
            [],
          )
          this.form.unit_Id = _.get(response.data, 'result.unitId', null)
          takeoffGroupings.map(element => {
            this.form.takeoff_Groupings.push(element.id)
            this.takeoff_Groupings.push({
              id: element.id,
              name: element.takeoffGrouping,
            })
          })
          this.form.unit_Cost = _.get(response.data, 'result.unitCost', null)
          if (this.form.unit) {
            const unit = this.unitList.find(i => i.option === this.form.unit)
            if (!unit) {
              this.unitList.push({
                option: this.form.unit,
                value: '',
              })
            }
          }
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Get Dropdowns Data
    getDropdowns() {
      const req = {
        unit: 0,
        takeoff_grouping: 0,
        category_code: 0,
        contract: 0,
      }
      instance
        .post(dropdownAPIs.dropdown, req)
        .then(response => {
          this.unitList = _.get(response.data, 'result.unit', [])
          this.takeoffGroupingList = _.get(
            response.data,
            'result.takeoff_grouping',
            [],
          )
          this.categoryCodeList = _.get(
            response.data,
            'result.category_code',
            [],
          ).map(element => {
            element['category_Code'] = element.option
            element['description'] = element.value
            element[
              'value'
            ] = `${element.category_Code} - ${element.description}`
            return element
          })
          this.contractList = _.get(response.data, 'result.contract', []).map(
            element => {
              element['contract'] = element.option
              element['contract_Name'] = element.value
              element.value = `${element.contract} - ${element.contract_Name}`
              return element
            },
          )
        })
        .catch(error => {
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.takeoff.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Takeoff',
            'Takeoff deleted successfully!',
          )
          this.refreshTakeoffs()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Show Takeoff Groupings
    showTakeoffGrouping() {
      this.visibleTakeoff = true
    },

    // Refresh Takeoff Groupings
    refreshTakeoffGroupings() {
      this.getTakeoffGroupings()
    },

    // Delete All Takeoff
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoffs ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              takeoffs
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Takeoff
    deleteTakeoff(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.takeoff_Grouping}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.takeoffList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'id'
        this.defaultSortOrder = true
      }
      this.getTakeoffs(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshTakeoffs()
      }
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    updateTable() {
      this.importClicked = false
      this.refreshTakeoffs()
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'takeoffTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.takeoffList = []
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.getTakeoffs(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.takeoffList = []
      this.loading = true
      this.page = 0
      this.getTakeoffs(this.gridOptions)
    },

    onCategoryCodeChange(value) {
      if (value === 'addCategory') {
        this.form.category_Code = undefined
        this.form.categoryCode = undefined
        this.isAddCategory = true
      } else {
        const categoryCode = this.categoryCodeList.find(i => i.value === value)
        if (value) {
          this.form.category_Code_Id = categoryCode.id
          this.form.asset_Class = categoryCode.asset_Class
            ? categoryCode.asset_Class
            : categoryCode.assetClass
          this.form.contract_Details_Id = categoryCode.contractId
          this.form.contractName = `${categoryCode.contract} - ${categoryCode.contractName}`
        }
      }
    },

    onContractChange(value) {
      const contract = this.contractList.find(i => i.value === value)
      if (contract) {
        this.form.contract_Details_Id = contract.id
      }
    },

    onChangeGroupings(value) {
      this.takeoff_Groupings = []
      value.forEach(element => {
        const group = this.takeoffGroupingList.find(i => i.id === element)
        if (group) {
          this.takeoff_Groupings.push({
            id: group.id,
            name: group.option,
          })
        }
      })
    },

    onUnitChange(value) {
      this.form.unit_Id = this.unitList.find(i => i.option === value).id
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings(data) {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.takeoff : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.takeoff : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', data || request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.takeoff,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getTakeoffs(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.takeoff))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getTakeoffs(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'id'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'id',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
